<template>
  <div class="maintenance-config" v-if="loadData && vehicle_info">
    <!-- 顶部车型信息 -->
    <div class="top">
      <div class="top-inner">
        <div class="brand-name">{{ vehicle_info.brand_name }}</div>
        <div class="common-car-name">
          {{
            vehicle_info.brand_name +
            " " +
            vehicle_info.model_name +
            "-" +
            vehicle_info.factory_name
          }}
        </div>
      </div>
    </div>
    <!-- 底部具体车型信息 -->
    <div class="detail">
      <div class="item">
        <div class="title">品牌</div>
        <div class="content">{{ vehicle_info.brand_name }}</div>
      </div>
      <div class="item">
        <div class="title">车型</div>
        <div class="content">
          {{ vehicle_info.model_name + "-" + vehicle_info.factory_name }}
        </div>
      </div>
      <div class="item">
        <div class="title">销售名称</div>
        <div class="content">{{ vehicle_info.sales_name }}</div>
      </div>
      <div class="item">
        <div class="title">款型年份</div>
        <div class="content">{{ vehicle_info.release_year }}</div>
      </div>
      <div class="item">
        <div class="title">生产年份</div>
        <div class="content">{{ vehicle_info.product_year }}</div>
      </div>
      <div class="item">
        <div class="title">停产年份</div>
        <div class="content">
          {{ vehicle_info.suspended_year ? vehicle_info.suspended_year : "--" }}
        </div>
      </div>
      <div class="item">
        <div class="title">排量</div>
        <div class="content">
          {{ vehicle_info.displacement_num + vehicle_info.displacement_unit }}
        </div>
      </div>
      <div class="item">
        <div class="title">进气形式</div>
        <div class="content">
          {{ vehicle_info.intake_form ? vehicle_info.intake_form : "--" }}
        </div>
      </div>
      <div class="item">
        <div class="title">燃油类型</div>
        <div class="content">{{ vehicle_info.fuel_type }}</div>
      </div>
      <div class="item">
        <div class="title">发动机型号</div>
        <div class="content">
          {{ vehicle_info.engine_model ? vehicle_info.engine_model : "--" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import wx from "weixin-js-sdk";
export default {
  name: "maintenance-config",
  data() {
    return {
      info: null,
      loadData: false,
    };
  },

  created() {
    this.getDetail();
  },
  mounted() {
    if (this.browser.wx == 1) {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
  },

  methods: {
    // 前往反馈页面
    feedback() {
      this.$router.push({
        path: "/maintenanc-feedback",
        query: { id: "1" },
      });
    },

    // 获取车辆详情信息
    getDetail() {
      let loading = this.$loading;
      loading.show("加载中...");
      api
        .getVehicleDetailApi({
          vehicle_id: this.$route.query.vehicle_id,
        })
        .then((data) => {
          loading.hide();
          if (data.code == 0) {
            this.loadData = true;
            this.vehicle_info = data.data;
          } else {
            this.$toast.show({
              showTime: 2,
              message: data.message,
              style: "error",
            });
          }
        });
    },

    // 返回
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.top {
  height: 321/100rem;
  background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
  .top-inner {
    height: 321/100rem;
    display: flex;
    flex-direction: column;
    background: url(https://select-oil-oss.vchangyi.com/wxapp/yellow-tire-bg.png)
      no-repeat;
    background-size: 365/100rem 365/100rem;
    background-position: 124% -30/100rem;
    .brand-name {
      margin: 27/100rem;
      font-weight: bold;
      color: #333333;
      line-height: 56/100rem;
      font-size: 41/100rem;
    }
    .common-car-name {
      margin-bottom: 38/100rem;
      margin-left: 29/100rem;
      color: #333333;
      line-height: 34/100rem;
      font-size: 24/100rem;
    }
  }
}
.detail {
  margin-top: -140/100rem;
  height: 80vh;
  padding: 27/100rem;
  background: #fff;
  box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.5);
  border-radius: 20/100rem 20/100rem 0 0;
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 38/100rem;
    font-size: 24/100rem;
    .title {
      flex-shrink: 0;
      width: 120/100rem;
      margin-right: 24/100rem;
      color: #999999;
      line-height: 20/100rem;
      font-size: 24/100rem;
    }
    .content {
      color: #666;
    }
  }
}
</style>
